module.exports = __webpack_public_path__ + "img/landing_box00.ad661524.jpg";